import React, {useState} from "react";

import {OfferType} from "../../../offer/types/OfferType";
import {IValueLabel} from "../../../variables/types/IValueLabel";
import {IPropertyDetail} from "../../types/IPropertyDetail";
import {PropertyAdditionalSpacesList} from "./PropertyAdditionalSpacesList";
import {PropertyAdditionalSpacesSummary} from "./PropertyAdditionalSpacesSummary";

export interface ISpace {
    id: number;
    name: string | null;
    comment: string | null;
    area: number | null;
    price: number | null;
    is_included_in_price: boolean;
    is_mandatory: boolean;
    selected: boolean;
}

interface IProps {
    additionalSpaces: IPropertyDetail["additional_areas_for_configurator"];
    variables: {
        property_additional_areas: IValueLabel[];
    };
    property: IPropertyDetail;
}

export const PropertyDetailAdditionalSpaces = (props: IProps) => {
    const getInitialAdditionalSpaces = () => {
        const propertySpace: ISpace = {
            id: 0,
            name: getPropertyName(props.property.offer.type),
            area: props.property.area,
            price: props.property.price,
            is_included_in_price: false,
            is_mandatory: true,
            selected: true,
            comment: null
        };

        return [
            propertySpace,
            ...props.additionalSpaces.map((space) => {
                return {
                    ...space,
                    selected: space.is_mandatory || space.is_included_in_price,
                    name: props.variables.property_additional_areas.find((variable) => variable.value === space.type)?.label ?? ""
                };
            })
        ];
    };

    const [additionalSpaces, setAdditionalSpaces] = useState<ISpace[]>(getInitialAdditionalSpaces());
    const handleSelectSpace = (space: ISpace) => {
        setAdditionalSpaces((prev) =>
            prev.map((s) => {
                if (s.id === space.id) {
                    return {...s, selected: !s.selected};
                }
                return s;
            })
        );
    };

    return (
        <>
            <PropertyAdditionalSpacesList additionalSpaces={additionalSpaces} onSpaceSelect={handleSelectSpace} />
            <PropertyAdditionalSpacesSummary additionalSpaces={additionalSpaces} />
        </>
    );
};

const getPropertyName = (offerType: OfferType) => {
    switch (offerType) {
        case OfferType.FLAT:
            return "Mieszkanie";
        case OfferType.HOUSE:
        case OfferType.MODULAR_HOUSE:
            return "Dom";
        case OfferType.COMMERCIAL:
            return "Budynek";
        default:
            return "Nieruchomość";
    }
};
import React, {useState} from "react";

import {OfferType} from "../../../offer/types/OfferType";
import {IValueLabel} from "../../../variables/types/IValueLabel";
import {IPropertyDetail} from "../../types/IPropertyDetail";
import {PropertyAdditionalSpacesList} from "./PropertyAdditionalSpacesList";
import {PropertyAdditionalSpacesSummary} from "./PropertyAdditionalSpacesSummary";

export interface ISpace {
    id: number;
    name: string | null;
    comment: string | null;
    area: number | null;
    price: number | null;
    is_included_in_price: boolean;
    is_mandatory: boolean;
    selected: boolean;
}

interface IProps {
    additionalSpaces: IPropertyDetail["additional_areas_for_configurator"];
    variables: {
        property_additional_areas: IValueLabel[];
    };
    property: IPropertyDetail;
}

export const PropertyDetailAdditionalSpaces = (props: IProps) => {
    const getInitialAdditionalSpaces = () => {
        const propertySpace: ISpace = {
            id: 0,
            name: getPropertyName(props.property.offer.type),
            area: props.property.area,
            price: props.property.price,
            is_included_in_price: false,
            is_mandatory: true,
            selected: true,
            comment: null
        };

        return [
            propertySpace,
            ...props.additionalSpaces.map((space) => {
                return {
                    ...space,
                    selected: space.is_mandatory || space.is_included_in_price,
                    name: props.variables.property_additional_areas.find((variable) => variable.value === space.type)?.label ?? ""
                };
            })
        ];
    };

    const [additionalSpaces, setAdditionalSpaces] = useState<ISpace[]>(getInitialAdditionalSpaces());
    const handleSelectSpace = (space: ISpace) => {
        setAdditionalSpaces((prev) =>
            prev.map((s) => {
                if (s.id === space.id) {
                    return {...s, selected: !s.selected};
                }
                return s;
            })
        );
    };

    return (
        <>
            <PropertyAdditionalSpacesList additionalSpaces={additionalSpaces} onSpaceSelect={handleSelectSpace} />
            <PropertyAdditionalSpacesSummary additionalSpaces={additionalSpaces} />
        </>
    );
};

const getPropertyName = (offerType: OfferType) => {
    switch (offerType) {
        case OfferType.FLAT:
            return "Mieszkanie";
        case OfferType.HOUSE:
        case OfferType.MODULAR_HOUSE:
            return "Dom";
        case OfferType.COMMERCIAL:
            return "Budynek";
        default:
            return "Nieruchomość";
    }
};
